import { RefundLogStatus } from "../../types/autoRefund";
import { SingleAlertResult, AutoResolveOutcome } from "../../types/alerts";
import { pascalCase } from "../../utils/textUtils";

export function processAutoResolveResult(result: SingleAlertResult): AutoResolveOutcome {
  if (result.skipped) {
    return { success: false, message: result.reason ? 'Skipped: ' + result.reason : 'Alert was skipped' };
  }
  if (result.status === RefundLogStatus.SUCCESS) {
    return { success: true };
  }
  if (result.status === RefundLogStatus.ETHOCA_VISA_SKIPPED) {
    return { success: true, message: 'Resolved as Other / Not Refunded (Visa refunds disabled)' };
  }
  if (result.status === RefundLogStatus.MAX_AMOUNT_EXCEEDED) {
    return { success: true, message: 'Alert Declined — Max Refund Amount Exceeded' };
  }
  if (result.status === RefundLogStatus.DUPLICATE_ALERT) {
    return { success: true, message: 'Resolved as Duplicate' };
  }
  if (result.status === RefundLogStatus.ALREADY_REFUNDED_NO_DUPLICATE) {
    return { success: true, message: 'Resolved as Already Refunded' };
  }
  return {
    success: false,
    message: result.errorMessage || pascalCase(result.status || 'Unknown error'),
  };
}
